<template>
  <SingleSelect
    v-model="adaptedValue"
    :searchable="false"
    :items="items"
    :label="label"
    :rules="rules"
    dense
    outlined
  >
    <template v-slot:selection="{item}">
      <span class="filter__summary text--disabled">
        {{ item.text }}
      </span>
    </template>
  </SingleSelect>
</template>

<script>
import SingleSelect from '@/components/filter/models/SingleSelect';

export default {
  name: 'FieldFilter',
  components: {
    SingleSelect,
  },
  props: {
    value: {
      type: String,
      default: '',
    },
    rules: {
      type: Array,
      default: () => ([]),
    },
    label: {
      type: String,
      required: true,
    },
    items: {
      type: Array,
      default: () => ([]),
    },
  },
  computed: {
    adaptedValue: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit('input', newValue);
      },
    },
  },
};

</script>

<style scoped lang="scss">
.filter__summary {
  margin-left: var(--ds-spacing-inline-nano);
}

</style>
